import { useEffect } from 'react';

const SELECTOR = '.reveal, [data-sequence]';

// Adds the .in class to reveal elements once their top passes 92% of the
// viewport. Checked by position, not intersection, so a jump (anchor link,
// find-in-page, fast fling) never leaves skipped content hidden.
const useReveal = () => {
  useEffect(() => {
    let pending = Array.from(document.querySelectorAll(SELECTOR));
    let frame = 0;

    const check = () => {
      frame = 0;
      const line = window.innerHeight * 0.92;
      pending = pending.filter((el) => {
        if (el.getBoundingClientRect().top < line) {
          el.classList.add('in');
          return false;
        }
        return true;
      });
      if (!pending.length) stop();
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(check);
    };
    const stop = () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();

    return () => {
      cancelAnimationFrame(frame);
      stop();
    };
  }, []);
};

export default useReveal;
